export default {"src":"/_next/static/media/office-arrow.e0f087b5.svg","height":36,"width":37,"blurWidth":0,"blurHeight":0};